import { generateAnonymousTokenRequest } from './api';
import cookies from '@/utils/cookies';

const ANONYMOUS_USER_TOKEN_TTL = 365 * 24;
const ANONYMOUS_USER_TOKEN_NAME = 'anonymousUserToken';

const initialState = {
  anonymousUserToken: cookies.getCookie(ANONYMOUS_USER_TOKEN_NAME) || null,
};

export default {
  state: initialState,
  mutations: {
    SET_ANONYMOUS_USER_TOKEN(state, token) {
      state.anonymousUserToken = token;

      cookies.setCookie({
        name: ANONYMOUS_USER_TOKEN_NAME,
        value: token,
        hours: ANONYMOUS_USER_TOKEN_TTL,
      });
    },
  },
  actions: {
    async generateAnonymousUserToken({ rootState, commit, getters }) {
      try {
        const session = rootState.session;
        const token = getters.anonymousUserToken;

        const { data } = await generateAnonymousTokenRequest({
          session,
          token,
        });
        const newToken = data.token;

        commit('SET_ANONYMOUS_USER_TOKEN', newToken);
      } catch (error) {
        console.error('Error generating anonymous user token:', error);
      }
    },
  },
  getters: {
    anonymousUserToken: state => state.anonymousUserToken,
  },
};
